import { Link, useLocation } from "react-router";
import Button from "core/components/Button";

const ButtonLink = ({ to, ...variantProps }) => {
  const location = useLocation();
  const as = to ? Link : "a";
  const externalProps = to
    ? {
        to: `${to}${location.search}`,
      }
    : {
        target: "_blank",
        rel: "noreferrer",
      };

  return <Button as={as} {...variantProps} {...externalProps} />;
};

export default ButtonLink;
